import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

const HeadWithNoIndexAndNoFollow = ({ title = null, description = null }) => (
  <NextSeo description={description} title={title} nofollow noindex />
);

HeadWithNoIndexAndNoFollow.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default HeadWithNoIndexAndNoFollow;
